import { useAuthStore } from '@/features/auth/stores/auth.store';
import { ROLES } from '@/features/rbac';
import { hasRole } from '@/shared/utils/rbac.utils';

/** True when the logged-in user is a super admin (tenant filter is super-admin–only). */
export function useIsSuperAdmin(): boolean {
  const user = useAuthStore(s => s.user);
  return hasRole(user, ROLES.SUPER_ADMIN);
}
